import {Component, OnInit, ViewChild, AfterViewInit, ViewChildren} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {historyUtils} from "./historyUtils";

import Swal from 'sweetalert2/dist/sweetalert2.js'
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import * as XLSX from 'xlsx';
import {DatePipe} from '@angular/common';

import {PDFfile} from 'src/app/device/PDFfile';
import {Router} from '@angular/router';
import {TraslateService} from 'src/app/traslate.service';

import {TooltipArea} from '@swimlane/ngx-charts';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {NgxSpinnerService} from 'ngx-spinner';
import {environment} from 'src/environments/environment';
import {debounceTime, delay, tap, filter, map, takeUntil} from 'rxjs/operators';


export type ChartOptions = {
  series: any;
  chart: any;
  xaxis: any;
  yaxis: any;
  title: any;
  fill: any;
  dataLabels: any;
  tooltips: any;
  annotations: any;
  stroke: any;
  markers: any;
  colors: string[];
  grid: any;
  legend: any;
};


export interface dataScore {
  name: string;
  x: number;
  y: number;
  z: number;
}


export interface dataRep {

  label: number;
  value: number;

}


export interface dataRep2 {

  value: number;
}


@Component({
  selector: 'app-historique-alarm',
  templateUrl: './historique-alarm.component.html',
  styleUrls: ['./historique-alarm.component.scss']
})
export class HistoriqueAlarmComponent implements OnInit {

  filter = '';
  myModel = false;
  chartOptions16: any;
  chartOptions17: any;
  manualPage: number = 0;
  pageSize1: any;
  pageSize = 5;
  lengthpage: number;
  pageNum: any;
  manualPage1: number;
  lengthTotal: any;
  URL: RequestInfo;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [15, 30, 100];
  public dateTime: Date
  index2: any = 5;
  dd: any = 0;
  pageSizeOptions1: number[];
  gg: any;
  itemSelect: any = [];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  itemSelect2: any;
  offsetPagination: any = 0;
  hiddenContenu: string = 'false';
  range: string;
  filterValue: string;
  repos2: PeriodicElementfilter[];
  refrech1: number = 2017;
  dt: any;
  days: any;
  finalDate: any;
  hiddenDetails: boolean = false;
  dtformt: string = "M/d/yyyy"
  // @ViewChild('paginator', {static: true}) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;
  jj: string;
  tblhidden: string;
  typeMessage: string;
  dataSourcee: any;
  ELEMENT_DATAFILTER: PeriodicElementfilter[]
  // dataSource: MatTableDataSource<PeriodicElementfilter>;
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  public searchControl: FormControl = new FormControl();
  getdt: string;
  panelOpenState = false;
  repos: any[] = [];
  reposdt: any;
  ELEMENT_DATAFILTER2: any;
  URL2: string;
  currentScore: any;
  type9: string;
  width9: string;
  height9: string;
  dataSource9: any;
  dataFetch: (string | number)[][];

  ELEMENTSCORE: dataScore[]
  xValues: any;
  series2: any[];
  customColors2: any;


  chartOptions: any;
  chartOptions2: any;
  chartOptions3: any;

  chartOptions4: any;
  chartOptions5: any;

  series1: any = [];
  ff: any = null

  series3: any = [];
  series4: any = [];
  fff: any = [];
  vv: any;
  yValues: any;
  evolutionScoreEconomie: boolean;
  evolutionScoreSecurite: boolean;
  typeEvenement: boolean;
  relationSecuriteEconomie: boolean;
  repartitionScoreSecurite: boolean;
  repartitionScoreEconomie: boolean;
  testFilter1: number;
  testFilter11: number;
  alarmHistory: boolean;


  goToBottom(e) {
    //console.log(document.body.scrollHeight)


    /*   window.scroll({
         top: e,
         left: 0,
         behavior: 'smooth'
       });*/
  }


  ngOnInit(): void {
    this.applyFilterer()

    // this.updateManualPage2(this.index2);


  }


  listAlarmHisto(operation) {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.alarmHistory = true
    this.spinnerAlarmHistory.show();
    if (!(this.dt2 && this.dt1)) {
      this.URL = environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id +
        '/alarms/log?page=' + this.offsetPagination + '&unit_name=' + this.filter;
    } else {
      this.URL = environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id +
        '/alarms/log/filter/ ' + new Date(this.dt1).toString().split('GMT')[0] + '~'
        + new Date(this.dt2).toString().split('GMT')[0] + '?page=' + this.offsetPagination + '&unit_name=' + this.filter;
    }
    this.http.get(this.URL, requestOptions).subscribe((response) => {
        // @ts-ignore
        this.repos = response?.data
        // @ts-ignore
        this.repos?.length = response?.total
        console.log("google", response)
        // this.collection = []
        // var lgn: any = this.lengthTotal
        // this.lengthpage = parseInt("" + (lgn + 1) / this.pageSize)

        //console.log(this.lengthpage)


        // if (this.lengthpage % 2 == 0) {
        //   for (var i = 0; i < this.lengthpage; i++) {
        //     this.collection.push(i + 1);
        //   }
        // } else {
        //   for (var i = 0; i < this.lengthpage + 1; i++) {
        //     this.collection.push(i + 1);
        //   }
        // }
        this.dataSource = new MatTableDataSource(this.repos);
        if(operation=='refreshData' || operation == 'serachByUnitName'){
          this.dataSource._updateChangeSubscription();
          this.paginator.pageIndex = 0;
        }
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinnerAlarmHistory.show()
        this.alarmHistory = false

      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

        this.spinnerAlarmHistory.hide();
      })


  }


  getUserrefrech() {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.alarmHistory = true
    this.spinnerAlarmHistory.show();
    this.http.get(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/alarms/log', requestOptions).subscribe((response) => {

        var listalarmHisto: any = response

        this.lengthTotal = listalarmHisto.length


        this.repos = listalarmHisto
        //console.log(this.repos)


        this.dataSource = new MatTableDataSource(this.repos);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;


        this.collection = []


        var lgn: any = this.lengthTotal
        this.lengthpage = parseInt("" + (lgn + 1) / this.pageSize)
        this.spinnerAlarmHistory.show()
        this.alarmHistory = false

      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

        this.spinnerAlarmHistory.hide();
      })

  }


  displayedColumns: string[] = ['unit_id', 'date', 'unit', 'type', 'detail', 'score', 'temps_ecoule'];
  // Assign the data to the data source for the table to render


  pipe: DatePipe;

  filterForm = new FormGroup({
    fromDate: new FormControl(),
    toDate: new FormControl(),
  });

  get fromDate() {
    return this.filterForm.get('fromDate').value;
  }

  get toDate() {
    return this.filterForm.get('toDate').value;
  }

  rangeFormGroup = new FormGroup({
    start: new FormControl(),
    end: new FormControl()

  })
  rangeFormGroup2 = new FormGroup({
    dt10: new FormControl(),


  })


  constructor(private _snackBar: MatSnackBar, private router: Router, public traslateService: TraslateService, private http: HttpClient, private spinnerAlarmHistory: NgxSpinnerService) {

    this.series1 = [];
    this.traslateService.obs.subscribe((response) => {
      this.traslateService.maptoAtelier(response, this.series1);
      //console.log(this.series1);
    });

    this.listAlarmHisto('')

  }


  /* dbClickitem(e){
    //console.log('jhjkhjk'+e)
    let url = 'user/events/details'
    this.router.navigate([url]);
  }
  */


  dbClickitem(e, i, t, m, search) {
    //console.log('jhjkhjk'+e)
    /*  let url = 'user/events/details'
     this.router.navigate([url]); */
    //console.log(i)
    localStorage.setItem('id_Vehicule', i)
    localStorage.setItem('id_manoeuvre', m)
    localStorage.setItem('filterValue', search)
    this.router.navigate(['user/vehicule/trajet/' + t]);
  }


  openSnackBar() {
    this._snackBar.open('Cannonball!!', 'End now', {
      duration: 500,

    });
  }

  applyFilterr() {
    this.dataSource.filter = '' + Math.random();
  }

  resetDate() {
    (<HTMLInputElement>document.getElementById('dateTime')).value = '';
    document.getElementById('dateTime').autofocus = false;
    this.dt2=null
    this.dt1=null
    this.listAlarmHisto('refreshData')
  }
  getFilter() {

    this.range = (<HTMLInputElement>document.getElementById('dateTime')).value
    //console.log(this.range.split(',')[0].split('/')[2])    //var firstD =this.range.split('~')[0].split(',')[0]
    var firstD = '9/23/2016'
    var firstT = this.range.split('~')[0].split(',')[1].split(' ')[1]
    // var secondD = this.range.split('~')[1].split(',')[0]
    var secondD = '9/23/2020'
    var secondT = this.range.split('~')[1].split(',')[1].split(' ')[1]
    var filterDT = firstD + '--' + secondD
    this.pipe = new DatePipe('en');
    //console.log( new Date(firstD).getUTCDate())
    var e = new Date(firstD).getUTCDate()
    //console.log(e)
    this.filterValue = filterDT.replace(/\s/g, "")
    const defaultPredicate = this.dataSource.filterPredicate;

  }

  updateColor(progress) {
    if (progress < 55) {
      return '#dc3545';
    } else if (progress > 75) {
      return '#28a745';
    } else {
      return '#fd8021';
    }
  }


  test() {

    let debut = new Date()
    //console.log(debut)
  }

  dt1
  dt2

  getdd() {
    this.range = (<HTMLInputElement>document.getElementById('dateTime')).value
    //console.log(this.range)
    var firstD = this.dt1 = this.range.split('~')[0].split('~')[0].split('(GMT')[0]
    //console.log('cc'+new Date(firstD))
    this.pipe = new DatePipe('en');
    const defaultPredicate = this.dataSource.filterPredicate;
    var firstD2 = this.dt2 = this.range.split('~')[1].split('~')[0].split('(GMT')[0]
    //console.log('ccc'+new Date(firstD2))


    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.alarmHistory = true;
    var url = environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/alarms/log/filter/ ' +
      new Date(firstD).toString().split('GMT')[0] + '~' + new Date(firstD2).toString().split('GMT')[0] + '?unit_name=' + this.filter
    this.http.get(url, requestOptions).subscribe((response: any) => {
        this.dataSource = new MatTableDataSource([]);
        // @ts-ignore
        this.repos = response?.data
        // @ts-ignore
        this.repos?.length = response?.total
        console.log("google", response)
        this.dataSource = new MatTableDataSource(this.repos);
        this.dataSource._updateChangeSubscription();
        this.paginator.pageIndex = 0;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinnerAlarmHistory.show()
        this.alarmHistory = false

      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })


      })


    this._snackBar.open('Filtrage date effectuer ' + this.range, 'Fermer', {
      duration: 2500,
    });

    //console.log('ff'+new Date(firstD)  +"new Date(firstD) ")
    //console.log(this.dataSource.filteredData.length)
    localStorage.setItem('repost', this.dataSource.filteredData.length.toString());


  }


  resetFilter() {
    this.searchControl.setValue('');
    this.filter=''
    this.listAlarmHisto('refreshData')
  }


  selectedRowIndex = -1;

  getItemDetails(e) {
    this.itemSelect = e;
    //console.log(e)
    this.selectedRowIndex = e.id;
    this.hiddenDetails = true
  }

  selectedRowIndex2 = -1;

  getItemDetails2(e) {
    this.itemSelect2 = e.forks;
//console.log(e)

    this.selectedRowIndex2 = e.id;
    this.hiddenContenu = 'jkhjk';


  }

  gettbldetils() {
    this.tblhidden = 'true';
  }

  gettbldetilsd() {
    this.tblhidden = 'jjj';
  }

  // MatPaginator Output
  pageEvent: PageEvent;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions1 = setPageSizeOptionsInput.split(',').map(str => +str);

    }

  }


  // public updateManualPage(index): void {
  //   //console.log(index)
  //   this.pageNum = index
  //   this.manualPage = index;
  //   this.paginator.pageIndex = index;
  //
  //   this.paginator.page.next({
  //     pageIndex: this.paginator.pageIndex,
  //     pageSize: this.paginator.pageSize,
  //     length: this.paginator.length
  //   });
  //
  //
  // }


  collection: any;

  // public updateManualPage2(index2): void {
  //   this.collection = []
//
// console.log(this.pageSizeOptions1)
  // this.paginator.pageSize = index2
  //
  // this.paginator.page.next({
  //   pageIndex: this.paginator.pageIndex,
  //   pageSize: this.paginator.pageSize,
  //   length: this.paginator.length
  // });
  //
  //
  // this.lengthpage = parseInt("" + (this.paginator.length + 1) / index2)

//console.log(this.lengthpage)

  // for (var i = 0; i < this.lengthpage; i++) {
  //   this.collection.push(i + 1);
  // }

//console.log(this.collection)
//   }

  applyFilterer() {
    this.searchControl.valueChanges.pipe(
      debounceTime(500)
    ).subscribe(value => {
      this.filter = value
      this.listAlarmHisto('serachByUnitName');
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    })
    // const filterValue = (event.target as HTMLInputElement).value;
    // this.dataSource.filter = filterValue.trim().toLowerCase();
    // if (this.dataSource.paginator) {
    //   this.dataSource.paginator.firstPage();
    //
    // }


  }

  exportExcel(e, e2) {


    Swal.fire({
      title: 'Souhaitez-vous exporter la table type .' + e2 + ' ?',
      showCancelButton: true,
      confirmButtonText: 'Exporter Fichier !',
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Export!',
          'Le fichier est exporté.'
        )
        //console.log(e);
        e.exportTable(e2, {
          fileName: 'STG_DRIVE_Evenement_date_' + new Date().toLocaleString(),
          sheet: 'STG DRIVE Evenement',
          Props: {'Author': 'STG_DRIVE'}
        })

      } else if (result.dismiss === Swal.DismissReason.cPDFfileancel) {
        Swal.fire(
          'Annuler',
          'Fichier non exporté !!'
        )
      }
    })

  }


  exportTable() {

    Swal.fire({
      title: 'Souhaitez-vous exporter la table ?',
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: 'Démarrer l\'exportation!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {


        historyUtils.exportToPdf("ExampleTable", "tbl");

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Annuler',
          'Fichier non exporté !!'
        )
      }
    })

  }

  pageChanged(event) {
    let pageIndex = event.pageIndex;
    let pageSize = event.pageSize;
    let previousIndex = event.previousPageIndex;
    let previousSize = pageSize * pageIndex;
    this.getNextData(previousSize, pageIndex.toString(), pageSize.toString());
  }

  getNextData(currentSize, offset, limit) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.alarmHistory = true;
    this.offsetPagination = parseInt(offset) + 1;
    if (!(this.dt2 && this.dt1)) {
      this.URL = environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id +
        '/alarms/log?page=' + this.offsetPagination + '&unit_name=' + this.filter;
    } else {
      this.URL = environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id +
        '/alarms/log/filter/ ' + new Date(this.dt1).toString().split('GMT')[0] + '~'
        + new Date(this.dt2).toString().split('GMT')[0] + '?page=' + this.offsetPagination + '&unit_name=' + this.filter;
    }
    (
      this.http.get(this.URL, requestOptions)
    ).subscribe((response) => {
      // @ts-ignore
      console.log("page", response)
      // @ts-ignore
      this.repos.length = currentSize;
      // @ts-ignore
      this.repos.push(...response.data);
      // @ts-ignore
      this.repos.length = response.total;
      this.alarmHistory = false;
      this.dataSource = new MatTableDataSource<any>(this.repos);
      this.dataSource._updateChangeSubscription();
      this.dataSource.paginator = this.paginator;
    });
  }


}


export interface PeriodicElementfilter {
  name: string;
  position: number;
  weight: number;
  weight1: number;
  weight2: number;
  pushed_at: Date;
  created_at: Date;
}



